import * as helper from '../../../../../VX/View/Assets/Js/helper';
import {PhoneSexNumbers} from "./PhoneSexNumbers";

// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
require('./../Sass/base.scss');

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
require('babel-polyfill');

helper.addEventListener(window, 'load', () => {
	const base = helper.$('#root');
	const {ver, ddi, callcenter} = JSON.parse(helper.getData(base, 'setup'));
	const h1 = base.querySelector('h1');
	const subline = helper.$('#subline');
	const number = helper.$('#number');
	const data = PhoneSexNumbers[ver];

	const {width, height} = base.getBoundingClientRect();
	if (width / height >= 3) {
		helper.addClass(base, 'wide');
	} else if (height / width > 3) {
		helper.addClass(base, 'tower');
	} else {
		helper.addClass(base, 'normal');
	}

	helper.addEventListener(base, 'click', () => {
		document.location.href = `tel:${data.number}${ddi}`;
	})

	h1.innerHTML = data.title;
	subline.innerHTML = data.subline;
	const html = helper.stringToHtml(`<a href="tel:${data.number[callcenter]}${ddi}">${data.number[callcenter]} ${ddi}</a>`);
	number.append(html);
	number.append(helper.stringToHtml('<p id="price">*2,49 €/Min</p>'))
})
